const KEY = 'brainstormy.composerDraft';

function readAll() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || '{}');
    return raw && typeof raw === 'object' ? raw : {};
  } catch {
    return {};
  }
}

function writeAll(all) {
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    /* the open box still has the line */
  }
}

export function rememberComposerDraft(sessionId, text) {
  if (!sessionId) return;
  const all = readAll();
  const value = String(text ?? '');
  if (!value) delete all[String(sessionId)];
  else all[String(sessionId)] = value;
  writeAll(all);
}

export function readComposerDraft(sessionId) {
  if (!sessionId) return '';
  const value = readAll()[String(sessionId)];
  return typeof value === 'string' ? value : '';
}

export function forgetComposerDraft(sessionId) {
  if (!sessionId) return;
  const all = readAll();
  if (!Object.prototype.hasOwnProperty.call(all, String(sessionId))) return;
  delete all[String(sessionId)];
  writeAll(all);
}

/** The latest writer line that is already stored. A stand-in row is not. */
export function persistedComposerEcho(messages) {
  const list = Array.isArray(messages) ? messages : [];
  for (let i = list.length - 1; i >= 0; i -= 1) {
    const message = list[i];
    const who = String(message?.speaker || message?.role || '').toLowerCase();
    if (who !== 'user') continue;
    const id = String(message?.id || '');
    if (id.startsWith('temp-')) return '';
    return String(message.content || '');
  }
  return '';
}

/** A line already saved in the thread should not also refill the box. */
export function composerDraftToShow(saved, echoText) {
  const text = String(saved || '');
  if (!text) return '';
  if (echoText && text === echoText) return '';
  return text;
}
